import styled from "styled-components";
import { breakpoints } from "theme/themes";

const StyledMenuButtons = styled.div`
    display: flex;
    align-items: center;

    .button {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      @media ${breakpoints.larger} {
        flex-direction: row;
      }

      .text {
        margin-top: 8px;
        font-family: ${({ theme }) => theme.fonts.fontHeavy};

        @media ${breakpoints.larger} {
          margin-top: 0;
          margin-left: 8px;
        }
      }
    }

    .button-exit {
      margin-left: 2rem;
      .icon {
        height: 24px;
      }
    }
  

  .hamburger {
    background: transparent;
    outline: 0;
    border: none;
    cursor: pointer;
    display: block;
    width: fit-content;
    height: fit-content;
    

    .line {
      display: block;
      width: 25px;
      height: 3px;
      background: ${(props) => props.color || "#595959"};
      transition: 400ms;
      transform-origin: 50% 50%;

      &:nth-child(2) {
        margin: 5px 0;
      }
    }

    &.is-active {
      + .text {
        transform: translateY(7px) ;

    @media ${breakpoints.large} {
      transform: none ;
    }
  }

      .line:nth-child(2) {
        opacity: 0;
        transform: translateX(-30px);
        margin: 0;
      }

      .line:nth-child(1) {
        margin: 0;
        transform: rotate(45deg) translateY(4px);
      }
      .line:nth-child(3) {
        margin: 0;
        transform: rotate(-45deg) translateY(-4px);
      }
    }
  }
`;

export default StyledMenuButtons;
